export const LOGIN_TYPE = {
  POPUP: 'popup',
  PAGE: 'page',
}

export const IAL_ERROR = {
  LOGIN_SELECTOR: {
    INIT_FAILED: {
      code: 113850,
      name: 'INIT_FAILED',
      message: 'IAL 로그인 셀렉터 초기화 실패',
    },
  },
}
